<template>
	<div class="filters-box">
		<div v-for="filter in filters" :key="filter.key" class="filter-item-box">
			<div class="filter-item" v-if="filter.list && filter.list.length > 0">
				<div class="label">{{ filter.label }}</div>
				<div :class="['filter-box', expands[filter.key] ? 'expand-all' : '']" :ref="filter.key">
					<div
						:class="['item-name', form[filter.key] === item.value ? 'active' : '']"
						v-for="(item, index) in filter.list"
						:key="index"
						@click="select(filter.key, item.value, filter.key2, item.value2)"
					>
						{{ item.label }}
					</div>
				</div>
				<div v-if="filter.show" :class="['more', expands[filter.key] ? 'expand' : '']" @click="expand(filter.key)">
					{{ expands[filter.key] ? '收起' : '展开' }}
					<i class="el-icon-arrow-down"></i>
				</div>
			</div>
		</div>
		<div class="filter-item-box">
			<div class="flex">
				<div class="filter-item center">
					<div class="label">搜索</div>
					<div>
						<el-input :placeholder="placeholder" @input="searchChange" v-model="searchInput" class="input-with-select" style="width: 320px">
							<el-select v-model="infoSelect" slot="prepend" placeholder="请选择" style="width: 118px">
								<el-option label="搜团长昵称" value="institutionName"></el-option>
								<el-option label="搜活动名称" value="activityName"></el-option>
							</el-select>
						</el-input>
					</div>
				</div>
			</div>
			<div style="margin-left: 80px">
				<el-button type="primary" @click="submit(true)">筛 选</el-button>
				<el-button @click="onClear">清 空</el-button>
			</div>
		</div>
	</div>
</template>
<script>
import { fansList, talentGradeList } from '@/utils/dataMap';
import { mapGetters } from 'vuex';
export default {
	created() {
		const { q = '' } = this.$route.query;
		this.searchInput = q;
	},
	watch: {
		// 达人信息切换时，清空输入框，删除form中的对应属性，避免下次搜索时带入
		infoSelect() {
			this.form.institutionName = '';
			this.form.activityName = '';
			this.searchInput = '';
		},
	},
	data() {
		return {
			form: {
				cate_id: '0',
				commission_rate_start: '',
				commission_rate_end: '',
				service_rate_start: '',
				service_rate_end: '',
				activityType: '',
				institutionName: '',
				activityName: '',
			},
			expands: {
				cate_id: false,
				commission_rate_start: false,
				service_rate_start: false,
				anchor_name: '',
			},
			fansList,
			talentGradeList,
			infoSelect: 'institutionName',
			searchInput: '',
		};
	},
	computed: {
		...mapGetters(['dyCategoryList']),
		filters() {
			let cateList = [{ value: '0', label: '不限' }, ...this.dyCategoryList];
			return [
				{
					label: '招商类目',
					key: 'cate_id',
					list: cateList,
					show: true,
				},
				{
					label: '佣金比例',
					key: 'commission_rate_start',
					key2: 'commission_rate_end',
					list: [
						{ value: '', value2: '', label: '不限' },
						{ value: 1, value2: 5, label: '1%-5%' },
						{ value: 5, value2: 10, label: '5%-10%' },
						{ value: 10, value2: 20, label: '10%-20%' },
						{ value: 20, value2: 100, label: '20%以上' },
					],
					show: false,
				},
				{
					label: '服务费率',
					key: 'service_rate_start',
					key2: 'service_rate_end',
					list: [
						{ value: '', value2: '', label: '不限' },
						{ value: 0, value2: 1, label: '1%以下' },
						{ value: 1, value2: 3, label: '1%-3%' },
						{ value: 3, value2: 5, label: '3%-5%' },
						{ value: 5, value2: 10, label: '5%-10%' },
						{ value: 10, value2: 100, label: '10%以上' },
					],
					show: false,
				},
			];
		},
		placeholder() {
			const placeholders = {
				institutionName: '请输入团长昵称',
				activityName: '请输入活动名称',
			};
			return placeholders[this.infoSelect] || '';
		},
	},
	methods: {
		select(key, value, key2, value2) {
			if (this.form[key] === value) return;
			this.form[key] = value;
			if (key2) {
				this.form[key2] = value2;
			}
		},
		expand(key) {
			this.expands[key] = !this.expands[key];
			this.$refs[key][0].scrollTo(0, 0);
		},
		submit(isInit) {
			this.$emit('onSubmit', this.form);
		},
		searchChange() {
			this.form[this.infoSelect] = this.searchInput;
		},
		onClear() {
			this.form = {
				cate_id: '0',
				commission_rate_start: '',
				commission_rate_end: '',
				service_rate_start: '',
				service_rate_end: '',
				anchor_name: '',
				activityType: '',
				institutionName: '',
				activityName: '',
			};
			this.infoSelect = 'institutionName';
			this.searchInput = '';
			this.submit(true);
		},
	},
};
</script>
<style lang="less" scoped>
.filters-box {
	width: 100%;
}
.filter-item {
	display: flex;
	padding: 12px 0;
	box-sizing: border-box;
	&.center {
		align-items: center;
	}
	.label {
		width: 56px;
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		font-weight: bold;
		color: #666;
		text-align: right;
		padding-right: 24px;
	}
}
.filter-box {
	display: flex;
	flex: 1;
	height: 22px;
	flex-wrap: wrap;
	overflow: hidden;
	&.expand-all {
		height: 80px;
		overflow-y: auto;
		&::-webkit-scrollbar {
			width: 6px;
		}
		&::-webkit-scrollbar-thumb {
			height: 26px;
			border-radius: 3px;
			background-color: @color-info;
		}
		.item-name {
			margin-bottom: 12px;
		}
	}
	.el-select {
		margin-right: 16px;
		width: 140px;
		::v-deep {
			&.el-input__inner {
				height: 24px;
			}
			&.el-input__icon {
				line-height: 24px;
			}
		}
	}
}
.item-name {
	padding: 2px 6px;
	font-size: 14px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	height: 20px;
	margin-right: 12px;
	color: #333;
	cursor: pointer;
	border-radius: 2px;
	background: #f6f9ff;
	&.active {
		color: @color-primary;
	}
	&:hover {
		color: @color-primary;
	}
}
.more {
	margin-left: 20px;
	height: 20px;
	display: flex;
	align-items: center;
	font-size: 12px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #606265;
	&:hover {
		color: @color-primary;
	}
	i {
		margin-left: 2px;
		transform: rotate(0);
		transition: all 0.3s;
	}
	cursor: pointer;
	&.expand {
		i {
			transform: rotate(180deg);
		}
	}
}
/deep/ .input-with-select .el-input-group__prepend {
	background-color: @color-white;
}
</style>
